<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/ds2-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">数字化应用开发</h2>
							<h4 class="text-left color-white">满足特定业务场景的应用开发及集成</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">业务挑战</h2>
				<div style="margin-top: 48px; font-size: 18px">
					<div class="function-inner">
						<div class="edit-container">
							<ul class="clearfix">
								<li>
									<div class="block-box js-m delay1 animate">
										<div class="title">业务数字化程度低</div>
										<div class="cont">经过多年的信息化、数字化建设，企业或组织内仍存在大量的线下业务或离线流程，无法实现企业全员、全业务在线化，企业数字化转型缺少有效的底层平台支撑。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay2 animate">
										<div class="title">业务流程不连贯</div>
										<div class="cont">随着组织内各类业务系统的增多，各类业务系统间独立性问题更加突出。组织全业务流程存在系统业务断点，无法实现完整的全流程业务线上化，数据及应用孤立，业务操作困难。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">业务系统不够人性化</div>
										<div class="cont">老旧业务系统或产品化的应用定制化服务能力弱，随着业务及技术的发展，各类系统在人机交互、协作关联、数据服务等方面已经无法满足业务拓展等要求，需要更强的适配能力。</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">服务价值</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">数字化应用交付服务</div>
										<div class="t2">基于全代码&低代码的数字化应用系统开发及交付，满足特定业务场景的应用开发及集成，提升企业业务信息化及数字化能力。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">数字化转型支撑</div>
										<div class="t2">提供底层平台支撑，助力企业实现从线下到线上的数字化转型。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">业务流程再造</div>
										<div class="t2">通过应用集成服务，打通系统间壁垒，实现全流程业务线上化。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">个性化服务与开发</div>
										<div class="t2">结合低代码开发和全代码定制服务，增强业务系统的人性化和适配能力。</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/ds2.jpg" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'About',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.edit-container {
	position: relative;
	ul {
		margin: 0 -10px;
		display: block;
		li {
			display: inline-block;
			vertical-align: top;
			width: 33.333%;
			padding: 0 10px;
			text-align: left;
			margin-top: 15px;

			.block-box {
				padding: 34px 42px;
				position: relative;
				font-size: 16px;
				background-color: #f7f9fc;
				box-shadow: 0 10px 12px rgba(148, 160, 175, 0.33);
				border-radius: 8px;
				overflow: hidden;

				&:before {
					content: '';
					width: 100%;
					height: 6px;
					background: linear-gradient(to right, #c60c1a, #2270b2);
					position: absolute;
					left: 0;
					bottom: 0;
				}

				.title {
					font-size: 20px;
					font-weight: bold;
					height: 60px;
				}

				.cont {
					line-height: 1.8;
					height: 160px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 6;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
}

.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}

}

.swiper-container {
	width: 100%;
	height: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		margin-top: 10%;
	}
	:deep(.swiper-pagination) {
		top: 70%;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
